import { REGIONS } from 'v2/configs/constants'

/**
 * What a data region actually costs you: which countries' numbers the org will
 * be able to rent. The rule is the one `country-lock-utils` enforces, and the
 * region is fixed once the org exists, yet the only place it was ever spelled
 * out was the buy-number blocker — after signup, after the choice (SER-6631).
 * Shown wherever a region is picked: signup, invite signup, create organization.
 */
const REGION_NUMBER_RULES: Record<string, string> = {
  [REGIONS.IN]:
    'India organizations can rent India numbers only. Numbers for other countries need a US organization.',
  [REGIONS.US]:
    'US organizations can rent numbers for every country except India. India numbers need an India organization.',
}

const CROSS_REGION_HINT = 'You can add one in the other data region later, free trial included.'

interface DataRegionNoteProps {
  region: string
  /** Append that the other region is still open to them. Not true at the per-region limit. */
  canAddOtherRegion?: boolean
  className?: string
}

/**
 * `text-secondary`, not the `text-tertiary` the other form notes use: this one
 * carries the constraint the ticket exists to surface, and tertiary measures
 * 2.57:1 against the form background (below AA).
 */
export const DataRegionNote = ({
  region,
  canAddOtherRegion = false,
  className,
}: DataRegionNoteProps) => (
  <p className={`text-xs-400 text-secondary ${className ?? ''}`} data-testid="data-region-note">
    {REGION_NUMBER_RULES[region] ?? REGION_NUMBER_RULES[REGIONS.US]}
    {canAddOtherRegion ? ` ${CROSS_REGION_HINT}` : ''}
  </p>
)
